export default __webpack_public_path__ + "static/media/Grimherald Hauberk.f888ee2e.jpg";